module.exports = __webpack_public_path__ + "img/icon-chevron-up.e41f24ee.svg";